import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import "react-tooltip/dist/react-tooltip.css";
import "./App.css";
import AppLayout from "../Features/AppLayout/AppLayout";

import AdminDash from "../Features/Admin/Dashboard";
import { Confirmation } from "../Features/Auth/Components/Confirmation";
import Inventory from "../Features/SuperAdmin/CreateApplication/Inventory";
import Test from "../Features/SuperAdmin/CreateApplication/Test";
import Survey from "../Features/SuperAdmin/CreateApplication/Survey";
import ApplicationResults from "../Features/SuperAdmin/ApplicationResults";
import InventoryAnswers from "../Features/SuperAdmin/CreateApplication/InventoryAnswers";
import { Scope, SubScope } from "../Features/SuperAdmin/CreateApplication/Scope";
import { Polar } from "../Features/SuperAdmin/CreateApplication/CreateQuestions/Questions/Polar";

import { Likert } from "../Features/SuperAdmin/CreateApplication/CreateQuestions/Questions/Likert";
import { CheckBox } from "../Features/SuperAdmin/CreateApplication/CreateQuestions/Questions/CheckBox";
import { TestItem } from "../Features/SuperAdmin/CreateApplication/CreateQuestions/Questions/TestItem";
import { ReorderQuestions } from "../Features/SuperAdmin/CreateApplication/CreateQuestions/ReorderQuestions";
import { ReorderCheckboxes } from "../Features/SuperAdmin/CreateApplication/CreateQuestions/ReorderCheckboxes";

import { HashLogin } from "../Features/Auth/Components/HashLogin";
import { ResetPassword } from "../Features/Auth/Components/ResetPassword";
import { ChangePassword } from "../Features/Auth/Components/ChangePassword";

import { MatchQuestions } from "../Features/SuperAdmin/CreateApplication/CreateQuestions/MatchQuestions";

import { RequireAuth } from "../Features/Auth/RequireAuth";
import BasicGraphSummary from "../Features/SuperAdmin/CreateApplication/ReportItems/BasicGraphSummary";
import BasicGraphDetail from "../Features/SuperAdmin/CreateApplication/ReportItems/BasicGraphDetail";
import MonoTextuary from "../Features/SuperAdmin/CreateApplication/ReportItems/MonoTextuary";
import DualTextuary from "../Features/SuperAdmin/CreateApplication/ReportItems/DualTextuary";
import ReportScheme from "../Features/SuperAdmin/CreateApplication/ReportScheme";
import Assessment from "../Features/SuperAdmin/CreateApplication/Assessment";
import ApplicationInfo from "../Features/SuperAdmin/CreateApplication/ApplicationInfo";
import InventoryWrapUp from "../Features/WrapUp/Components/InventoryWrapUp";
import TestWrapUp from "../Features/WrapUp/Components/TestWrapUp";

import Company from "../Features/SuperAdmin/CreateCompany/Company";
import CompanyUser from "../Features/SuperAdmin/CreateCompany/CompanyUser";
import Credits from "../Features/SuperAdmin/CreateCompany/Credits";
import Position from "../Features/Admin/Position/Components/Position";
import CreatePosition from "../Features/Admin/CreatePosition";
import CreateCandidate from "../Features/Admin/CreateCandidate";
import CompanyInfo from "../Features/SuperAdmin/CreateCompany/CompanyInfo";
import Candidate from "../Features/Admin/Candidate/Components/Candidate";
import AdminCompanyInfo from "../Features/Admin/AdminCompanyInfo";
import UserDash from "../Features/User/UserDash";
import Project from "../Features/Admin/Project";
import { B2bInventory } from "../Features/AnsweringApplication/AnswerInventoryApp/B2bInventory";
import DemographyForm from "../Features/User/Demography";
import { B2bTest } from "../Features/AnsweringApplication/AnswerTestApp/B2bTest";
import UserProfile from "../Features/User/UserProfile";
import UserResults from "../Features/User/Results";
import TicketEditor from "../Features/SuperAdmin/TicketDataEditor/Components/TicketEditor";
import LandingPage from "../Features/LandingPage/Pages/LandingPage/LandingPage";
import Contact from "../Features/LandingPage/Pages/Contact/Contact";
import SadminDash from "../Features/SuperAdmin/SadminDash";
import SuperAdminHelpDesk from "../Features/SuperAdmin/HelpDesk";
import Organization from "../Features/SuperAdmin/Organization";
import Squads from "../Features/Admin/Squads";
import SkillAnalytics from "../Features/LandingPage/Pages/SkillAnalytics/SkillAnalytics";
import SkillManagement from "../Features/LandingPage/Pages/SkillManagement/SkillManagement";
import IndividualServices from "../Features/LandingPage/Pages/IndividualServices/IndividualServices";
import AboutUs from "../Features/LandingPage/Pages/AboutUs/AboutUs";
import AssessmentLibrary from "../Features/LandingPage/Pages/AssessmentLibrary/AssessmentLibrary";
import Pricing from "../Features/LandingPage/Pages/Pricing/Pricing";
import Founders from "../Features/LandingPage/Pages/Founders/Founders";
import HelpDesk from "../Features/SharedComponents/HelpDesk";
import ScrollResetHelper from "../Helpers/ScrollResetHelper";
import NewLogin from "../Features/Auth/Components/NewLogin";
import NewRegister from "../Features/Auth/Components/NewRegister";
import NotFound from "../Features/SharedComponents/NotFound/NotFound";

function App() {
  const prevLocation = window.location.href;
  return (
    <HashRouter>
      <AppLayout>
        <Routes>
          <Route element={<RequireAuth allowedRoles={["SuperAdmin"]} />}>
            <Route path="/sdash" element={<SadminDash />}></Route>
            <Route path="/assessment" element={<Assessment />}></Route>
            <Route path="/inventory" element={<Inventory />}></Route>
            <Route path="/survey" element={<Survey />}></Route>
            <Route path="/company" element={<Company />}></Route>
            <Route path="/companyUsers" element={<CompanyUser />}></Route>
            <Route path="/credits" element={<Credits />}></Route>
            <Route path="/test" element={<Test />}></Route>
            <Route path="/info" element={<ApplicationInfo />}></Route>
            <Route path="/answers" element={<InventoryAnswers />}></Route>
            <Route path="/ApplicationResults/" element={<ApplicationResults />}></Route>
            <Route path="/scope" element={<Scope />}></Route>
            <Route path="/subscope" element={<SubScope />}></Route>
            <Route path="/polar" element={<Polar />}></Route>
            <Route path="/likert" element={<Likert />}></Route>
            <Route path="/checkbox" element={<CheckBox />}></Route>
            <Route path="/testItem" element={<TestItem />}></Route>
            <Route path="/reorder" element={<ReorderQuestions />}></Route>
            <Route path="/reordercheckboxes" element={<ReorderCheckboxes />}></Route>
            <Route path="/match" element={<MatchQuestions />}></Route>
            <Route path="/basicGraphSummary" element={<BasicGraphSummary />}></Route>
            <Route path="/basicGraphDetail" element={<BasicGraphDetail />}></Route>
            <Route path="/monotextuary" element={<MonoTextuary />}></Route>
            <Route path="/dualtextuary" element={<DualTextuary />}></Route>
            <Route path="/scheme" element={<ReportScheme />}></Route>
            <Route path="/companyInfo" element={<CompanyInfo />}></Route>
            <Route path="/ticketEditor" element={<TicketEditor />}></Route>
            <Route path="/superAdminHelpDesk" element={<SuperAdminHelpDesk />}></Route>
            <Route path="/organization" element={<Organization />}></Route>
          </Route>

          <Route element={<RequireAuth allowedRoles={["Admin"]} />}>
            <Route path="/adminCompanyInfo" element={<AdminCompanyInfo />}></Route>
            <Route path="/dash" element={<AdminDash />}></Route>
            <Route path="/createPosition" element={<CreatePosition />}></Route>
            <Route path="/position" element={<Position />}></Route>
            <Route path="/createCandidate" element={<CreateCandidate />}></Route>
            <Route path="/candidate" element={<Candidate />}></Route>
            <Route path="/project" element={<Project />}></Route>
            <Route path="/squads" element={<Squads />}></Route>
            <Route path="/iwrapup/:inventoryResultId" element={<InventoryWrapUp />}></Route>
            <Route path="/twrapup/:testResultId" element={<TestWrapUp />}></Route>
          </Route>

          <Route element={<RequireAuth allowedRoles={["User"]} />}>
            <Route path="/userdash" element={<UserDash />}></Route>
            <Route path="/myResults" element={<UserResults />}></Route>
            <Route path="/myProfile" element={<UserProfile />}></Route>
            <Route path="/invapp/:invId/:ticketId" element={<B2bInventory />}></Route>
            <Route path="/testapp/:testId/:ticketId" element={<B2bTest />}></Route>
            <Route path="/iresult/:inventoryResultId" element={<InventoryWrapUp />}></Route>
            <Route path="/tresult/:testResultId" element={<TestWrapUp />}></Route>
            <Route path="/demographyForm" element={<DemographyForm />}></Route>
          </Route>

          <Route element={<RequireAuth allowedRoles={["User", "Admin"]} />}>
            <Route path="/helpDesk" element={<HelpDesk />}></Route>
          </Route>

          <Route element={<RequireAuth allowedRoles={["User", "Admin", "SuperAdmin"]} />}>
            <Route path="/change-password" element={<ChangePassword />}></Route>
          </Route>

          <Route element={<RequireAuth allowedRoles={["User", "Admin", "SuperAdmin"]} checkLogin={true} />}>
            <Route path="/Login" element={<NewLogin />}></Route>
            <Route path="/Register" element={<NewRegister />}></Route>
            <Route path="/Confirmation" element={<Confirmation />}></Route>
            <Route path="/reset-password" element={<ResetPassword />}></Route>

            <Route element={<ScrollResetHelper />}>
              <Route path="/" element={<LandingPage prevLocation={prevLocation} />}></Route>
              <Route path="/aboutUs" element={<AboutUs />}></Route>
              <Route path="/contact" element={<Contact />}></Route>
              <Route path="/founders" element={<Founders />}></Route>
              <Route path="/skillAnalytics" element={<SkillAnalytics />}></Route>
              <Route path="/skillManagement" element={<SkillManagement />}></Route>
              <Route path="/individualServices" element={<IndividualServices />}></Route>
              <Route path="/assessmentLibrary" element={<AssessmentLibrary />}></Route>
              <Route path="/pricing" element={<Pricing />}></Route>
            </Route>
            <Route path="/hashlogin/:hash" element={<HashLogin />}></Route>
          </Route>

          {/* Catch-all route for 404 Not Found */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppLayout>
    </HashRouter>
  );
}

export default App;
